import { toast } from 'react-toastify';
import { all, call, fork, takeLatest } from 'redux-saga/effects';
import { FailToastContainer } from 'components/Toast/ToastContainer';
import { GENERIC_TOAST_ERROR_MESSAGE } from 'config/const';
import { IApiAction } from 'types';

export function* handleFail(action: IApiAction) {
  if (action.meta?.failToast) {
    yield call(toast, FailToastContainer({ message: action.meta.failToast.message || GENERIC_TOAST_ERROR_MESSAGE }), { toastId: 'unexpected-error' });
  }
}

export function* watchHandleFail() {
  yield takeLatest((action: any) => action.type?.endsWith('FAIL'), handleFail);
}

function* apiSaga() {
  yield all([fork(watchHandleFail)]);
}
export { apiSaga };
